import React from 'react';
import './AutoCarousel.css';

const AutoCarousel = () => {
    return (
        <div id="slider">
            <figure>
                <img src="/imgs/img1.gif" alt="" />
                <img src="/imgs/img2.gif" alt="" />
                <img src="/imgs/img3.gif" alt="" />
                <img src="/imgs/img1.gif" alt="" />
                <img src="/imgs/img2.gif" alt="" />
            </figure>
        </div>
    );
};

export default AutoCarousel;
